import { ReactNode } from 'react';

interface SectionProps {
  children: ReactNode;
  className?: string;
  background?: 'white' | 'light' | 'dark' | 'gradient';
  padding?: 'sm' | 'md' | 'lg';
  id?: string;
}

export default function Section({ 
  children, 
  className = '', 
  background = 'white',
  padding = 'lg',
  id
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    light: 'bg-light',
    dark: 'bg-secondary text-white',
    gradient: 'bg-gradient-to-br from-primary to-secondary text-white',
  };
  
  const paddings = {
    sm: 'py-12',
    md: 'py-16',
    lg: 'py-20',
  };
  
  return (
    <section id={id} className={`${backgrounds[background]} ${paddings[padding]} overflow-hidden ${className}`}>
      <div className="container mx-auto px-4 max-w-7xl">
        {children}
      </div>
    </section>
  );
}
